import React from 'react';
import { clsx } from 'clsx';

type PillIcon = 'wallet' | 'cuisine' | 'food-type' | 'location';

type IconPillProps = {
  icon: PillIcon;
  children: React.ReactNode;
  inverted?: boolean;
  large?: boolean;
};

const IconPill: React.FC<IconPillProps> = ({
  icon,
  children,
  inverted,
  large,
}) => (
  <span className={clsx('icon-pill', icon, { inverted, large })}>
    {children}
  </span>
);

export default IconPill;
